import { render, staticRenderFns } from "./gongshi.vue?vue&type=template&id=54f8a821&scoped=true&"
import script from "./gongshi.vue?vue&type=script&lang=js&"
export * from "./gongshi.vue?vue&type=script&lang=js&"
import style0 from "./gongshi.vue?vue&type=style&index=0&id=54f8a821&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8a821",
  null
  
)

export default component.exports